export default __webpack_public_path__ + "static/media/x-mark.ae506d6c.svg";